// src/context/LeagueContext.js
import React, { createContext, useContext, useState } from "react";

const LeagueContext = createContext();

export const useLeague = () => useContext(LeagueContext);

export const LeagueProvider = ({ children }) => {
  const [leagueId, setLeagueId] = useState(null);

  return (
    <LeagueContext.Provider value={{ leagueId, setLeagueId }}>
      {children}
    </LeagueContext.Provider>
  );
};
